










import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import draggable from 'vuedraggable'

@Component({
  components: {
    draggable,
  },
})
export default class MiniatureView extends Vue {
  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly draggable!: boolean

  @Prop({
    type: Array,
  })
  public readonly value?: any[]

  public emitValue(value: any[]) {
    this.$emit('input', value)
  }
}
